module.exports = __webpack_public_path__ + "img/future.edb17b51.svg";